import { EventsFindResponseBodyEventsDto } from '../api/events';
import { EVENT_STATUS_V2 } from './common';

export class EventItemV2 {
  id: number;
  url: string;
  status: EVENT_STATUS_V2;
  mainTitle: string;
  contents: string;
  memo: string;
  startDate: string | null;
  endDate: string | null;
  updateDate: string;

  constructor(event: EventsFindResponseBodyEventsDto) {
    this.id = event.id;
    this.url = event.eventAttachments[0]?.url || '';
    this.status = event.status;
    this.mainTitle = event.mainTitle;
    this.contents = event.contents;
    this.memo = event.memo;
    this.startDate = event.startDate;
    this.endDate = event.endDate;
    this.updateDate = event.updateDate;
  }
}
